import styled from 'styled-components';

import CrossIcon from '../../Images/CrossIcon';

const OptionsDropDown = styled.div`
  width: 320px;
  max-height: 352px;
  overflow-y: auto;
  box-shadow: 0 20px 40px 0 rgba(24, 27, 37, 0.16);
  background-color: var(--Dove);
  position: ${({ isAbsolutelyPositioned }) =>
    !isAbsolutelyPositioned && 'absolute'};
  top: 0;
  left: 0;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  z-index: 1000;
`;
const Option = styled.div`
  background-color: var(--Dove);
  padding: 16px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  color: var(--Text500);

  &:hover {
    background-color: var(--Grey500);
  }
`;

const BoldSpan = styled.span`
  color: var(--Text900);
`;

const Label = styled.label`
  margin-right: 6px;
`;
const LabelDiv = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  top: 6px;
  line-height: 1.33;
  text-align: left;
  color: var(--Text300);
  position: absolute;
`;

const SelectionField = styled.div`
  position: relative;
  min-height: 50px;
  display: flex;
  flex-wrap: wrap;
  border-radius: 4px;
  border: solid 1px var(--Grey900);
  background-color: var(--Grey300);
  padding: 24px 16px 14px 16px;

  &:focus-within {
    background-color: var(--Dove);
    border: solid 2px var(--Azure500);
    padding: 23px 7px 13px 7px;
  }
`;

const SelectedSpan = styled.span`
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  color: var(--Text700);
  justify-content: space-between;
`;

const Input = styled.input`
  flex-grow: 1;
  border: none;
  background-color: var(--Grey300);
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  color: var(--Text700);
  margin-top: 3px;
  min-height: 36px;
  cursor: ${({ readOnly }) => (readOnly ? 'not-allowed' : 'auto')};
  &:focus {
    outline: none;
  }

  &:focus {
    background-color: var(--Dove);
  }
`;

const StyledCrossIcon = styled(CrossIcon)`
  align-self: center;
  fill: #0d1536;
  fill-opacity: 0.65;
  pointer-events: ${({ readOnly }) => (readOnly ? 'none' : 'auto')};
`;

export {
  StyledCrossIcon,
  OptionsDropDown,
  Option,
  BoldSpan,
  Label,
  LabelDiv,
  SelectedSpan,
  SelectionField,
  Input,
};
